import { BaseDatePlugin } from "@platejs/date";

import { DateElementStatic } from "@/components/ui/date-node-static";

export const BaseDateKit = [BaseDatePlugin.withComponent(DateElementStatic)];
